import axios from 'axios';
import * as Err from '@fixtuur/error-context';
import { pipe } from 'fp-ts/lib/function';
import * as TE from 'fp-ts/TaskEither';
import { RequestError } from './requestError';
import * as Url from '../api/url';
export const request = (serviceUrl) => (props) => pipe(TE.Do, TE.bind('basketUrl', () => TE.right(Url.toString({ base: serviceUrl, path: '/basket', query: {} }))), TE.bind('body', () => TE.right(props.options != null ? props : { particles: props.particles })), TE.bind('response', ({ basketUrl, body }) => TE.tryCatch(() => axios.post(basketUrl, body), err => Err.construct(RequestError.FetchError, {
    error: err?.message,
    basketUrl,
}))));
